import { Card, CardContent } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Button } from '../ui/button';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../ui/alert-dialog';
import { Crown, ToggleLeft, ToggleRight, Eye, Trash2 } from 'lucide-react';

export function AdminUsersTable({ users, onToggleStatus, onViewUser, onDeleteUser }) {
  return (
    <Card className="bg-card border-border" data-testid="admin-users-table">
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Utilisateur</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Statut</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">QCM</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Copies</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Inscrit le</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground w-40">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((u) => (
              <TableRow key={u.user_id} className="hover:bg-muted/30 transition-colors" data-testid={`admin-user-row-${u.user_id}`}>
                <TableCell>
                  <div className="flex items-center gap-3">
                    {u.picture ? (
                      <img src={u.picture} alt="" className="w-8 h-8 rounded-full" />
                    ) : (
                      <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-xs font-bold text-primary">
                        {u.name?.[0] || '?'}
                      </div>
                    )}
                    <div>
                      <p className="font-medium text-sm">{u.name || 'Sans nom'}</p>
                      <p className="text-xs text-muted-foreground">{u.email}</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  {u.status === 'abonne' ? (
                    <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-bold rounded-full bg-amber-400/10 text-amber-400 border border-amber-400/30">
                      <Crown className="w-3 h-3" /> Pro
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full bg-secondary text-muted-foreground border border-border">
                      Gratuit
                    </span>
                  )}
                </TableCell>
                <TableCell className="text-sm font-medium">{u.quiz_count}</TableCell>
                <TableCell className="text-sm font-medium">{u.results_count}</TableCell>
                <TableCell className="text-xs text-muted-foreground">
                  {u.created_at ? new Date(u.created_at).toLocaleDateString('fr-FR') : '-'}
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-1">
                    <Button
                      size="sm"
                      variant={u.status === 'abonne' ? 'default' : 'secondary'}
                      onClick={() => onToggleStatus(u.user_id, u.status || 'gratuit', u.name)}
                      data-testid={`toggle-status-${u.user_id}`}
                      className={`text-xs h-8 ${u.status === 'abonne' ? 'bg-amber-500 hover:bg-amber-600 text-white' : 'border border-border hover:border-amber-400/50 hover:text-amber-400'}`}
                    >
                      {u.status === 'abonne' ? (
                        <><ToggleRight className="w-3.5 h-3.5 mr-1" /> Pro</>
                      ) : (
                        <><ToggleLeft className="w-3.5 h-3.5 mr-1" /> Gratuit</>
                      )}
                    </Button>
                    <Button size="sm" variant="ghost" onClick={() => onViewUser(u.user_id)} data-testid={`view-user-${u.user_id}`} className="text-muted-foreground hover:text-primary h-8">
                      <Eye className="w-4 h-4" />
                    </Button>
                    <AlertDialog>
                      <AlertDialogTrigger asChild>
                        <Button size="sm" variant="ghost" data-testid={`delete-user-${u.user_id}`} className="text-muted-foreground hover:text-destructive h-8" title="Supprimer le compte">
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </AlertDialogTrigger>
                      <AlertDialogContent className="bg-card border-border">
                        <AlertDialogHeader>
                          <AlertDialogTitle>Supprimer le compte</AlertDialogTitle>
                          <AlertDialogDescription>
                            Supprimer le compte de {u.name} ({u.email}) et TOUTES ses données ? Cette action est irréversible.
                          </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                          <AlertDialogCancel>Annuler</AlertDialogCancel>
                          <AlertDialogAction onClick={() => onDeleteUser(u.user_id)} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
                            Supprimer
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialog>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
